import { spacesApi } from '@/api/spacesApi/spacesAPIclient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useMarkSpaceActivitiesAsRead = (spaceId?: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      if (!spaceId) return
      await spacesApi.post(`/activity/setLastRead/${spaceId}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['unreadSpaceActivities', spaceId])
    },
  })
}
